const modal = {
  namespaced: true,
  state: {
    showingCallingStaffModal: false, // 初回の場合は false から,
    showingCheckingOutModal: false,
    showingChildrenAuthorizedModal: false,
    showingOrderQuittingModal: false,
    showingQRForChildrenModal: false,
    showingScheduledRecommendModal: false,
    showingSeatAuthorizedModal: false,
    showingShopAuthorizedModal: false,
    showingSimpleErrorModal: false,
    showingTutorialModal: false,
    showingBirthMonthEventModal: false,
    showingReserveInfoModal: false,
    showingVoiceSearchModal: false,
    showingPreOrderWarningModal: false,
    showingPlayBikkuraponModal: false,
    showingBikkuraponBusyModal: false,
    showingBikkuraponErrorModal: false,
    showingBikkuraponAnimationModal: false,
    showingSelfcheckModal: false,
    showingSelfcheckCallingModal: false,
    showingSelfcheckErrorModal: false,
    showingSelfcheckInitErrorModal: false,
    showingSelfcheckUnhandledErrorModal: false,
    showingModal: false,
  },
  getters: {
    isShowingCallingStaffModal: (state) => {
      return state.showingCallingStaffModal
    },
    isShowingCheckingOutModal: (state) => {
      return state.showingCheckingOutModal
    },
    isShowingChildrenAuthorizedModal: (state) => {
      return state.showingChildrenAuthorizedModal
    },
    isShowingOrderQuittingModal: (state) => {
      return state.showingOrderQuittingModal
    },
    isShowingQRForChildrenModal: (state) => {
      return state.showingQRForChildrenModal
    },
    isShowingScheduledRecommendModal: (state) => {
      return state.showingScheduledRecommendModal
    },
    isShowingSeatAuthorizedModal: (state) => {
      return state.showingSeatAuthorizedModal
    },
    isShowingShopAuthorizedModal: (state) => {
      return state.showingShopAuthorizedModal
    },
    isShowingSimpleErrorModal: (state) => {
      return state.showingSimpleErrorModal
    },
    isShowingTutorialModal: (state) => {
      return state.showingTutorialModal
    },
    isShowingBirthMonthEvent: (state) => {
      return state.showingBirthMonthEventModal
    },
    isShowingReserveInfoModal: (state) => {
      return state.showingReserveInfoModal
    },
    isShowingVoiceSearchModal: (state) => {
      return state.showingReserveInfoModal
    },
    isShowingPreOrderWarningModal: (state) => {
      return state.showingPreOrderWarningModal
    },
    isShowingPlayBikkuraponModal: (state) => {
      return state.showingPlayBikkuraponModal
    },
    isShowingBikkuraponBusyModal: (state) => {
      return state.showingBikkuraponBusyModal
    },
    isShowingBikkuraponErrorModal: (state) => {
      return state.showingBikkuraponErrorModal
    },
    isShowingBikkuraponAnimationModal: (state) => {
      return state.showingBikkuraponAnimationModal
    },
    isShowingSelfcheckModal: (state) => {
      return state.showingSelfcheckModal
    },
    isShowingSelfcheckCallingModal: (state) => {
      return state.showingSelfcheckCallingModal
    },
    isShowingSelfcheckErrorModal: (state) => {
      return state.showingSelfcheckErrorModal
    },
    isShowingSelfcheckInitErrorModal: (state) => {
      return state.showingSelfcheckInitErrorModal
    },
    isShowingSelfcheckUnhandledErrorModal: (state) => {
      return state.showingSelfcheckUnhandledErrorModal
    },
    isShowingModal: (state) => {
      return (
        state.showingCallingStaffModal ||
        state.showingCheckingOutModal ||
        state.showingChildrenAuthorizedModal ||
        state.showingOrderQuittingModal ||
        state.showingQRForChildrenModal ||
        state.showingScheduledRecommendModal ||
        state.showingSeatAuthorizedModal ||
        state.showingShopAuthorizedModal ||
        state.showingSimpleErrorModal ||
        state.showingTutorialModal ||
        state.showingBirthMonthEventModal ||
        state.showingReserveInfoModal ||
        state.showingPlayBikkuraponModal ||
        state.showingBikkuraponBusyModal ||
        state.showingBikkuraponErrorModal ||
        state.showingBikkuraponAnimationModal ||
        state.showingSelfcheckModal ||
        state.showingSelfcheckCallingModal ||
        state.showingSelfcheckErrorModal ||
        state.showingSelfcheckInitErrorModal ||
        state.showingSelfcheckUnhandledErrorModal
      )
    },
  },
  actions: {
    setShowingCallingStaffModal: ({ commit }, payload) => {
      commit('setShowingCallingStaffModal', payload)
    },
    setShowingCheckingOutModal: ({ commit }, payload) => {
      commit('setShowingCheckingOutModal', payload)
    },
    setShowingChildrenAuthorizedModal: ({ commit }, payload) => {
      commit('setShowingChildrenAuthorizedModal', payload)
    },
    setShowingOrderQuittingModal: ({ commit }, payload) => {
      commit('setShowingOrderQuittingModal', payload)
    },
    setShowingQRForChildrenModal: ({ commit }, payload) => {
      commit('setShowingQRForChildrenModal', payload)
    },
    setShowingScheduledRecommendModal: ({ commit }, payload) => {
      commit('setShowingScheduledRecommendModal', payload)
    },
    setShowingSeatAuthorizedModal: ({ commit }, payload) => {
      commit('setShowingSeatAuthorizedModal', payload)
    },
    setShowingShopAuthorizedModal: ({ commit }, payload) => {
      commit('setShowingShopAuthorizedModal', payload)
    },
    setShowingSimpleErrorModal: ({ commit }, payload) => {
      commit('setShowingSimpleErrorModal', payload)
    },
    setShowingTutorialModal: ({ commit }, payload) => {
      commit('setShowingTutorialModal', payload)
    },
    setShowingBirthMonthEventModal: ({ commit }, payload) => {
      commit('setShowingBirthMonthEventModal', payload)
    },
    setShowingReserveInfoModal: ({ commit }, payload) => {
      commit('setShowingReserveInfoModal', payload)
    },
    setShowingVoiceSearchModal: ({ commit }, payload) => {
      commit('setShowingVoiceSearchModal', payload)
    },
    setShowingPreOrderWarningModal: ({ commit }, payload) => {
      commit('setShowingPreOrderWarningModal', payload)
    },
    setShowingPlayBikkuraponModal: ({ commit }, payload) => {
      commit('setShowingPlayBikkuraponModal', payload)
    },
    setShowingBikkuraponBusyModal: ({ commit }, payload) => {
      commit('setShowingBikkuraponBusyModal', payload)
    },
    setShowingBikkuraponErrorModal: ({ commit }, payload) => {
      commit('setShowingBikkuraponErrorModal', payload)
    },
    setShowingBikkuraponAnimationModal: ({ commit }, payload) => {
      commit('setShowingBikkuraponAnimationModal', payload)
    },
    setShowingSelfcheckModal: ({ commit }, payload) => {
      commit('setShowingSelfcheckModal', payload)
    },
    setShowingSelfcheckCallingModal: ({ commit }, payload) => {
      commit('setShowingSelfcheckCallingModal', payload)
    },
    setShowingSelfcheckErrorModal: ({ commit }, payload) => {
      commit('setShowingSelfcheckErrorModal', payload)
    },
    setShowingSelfcheckInitErrorModal: ({ commit }, payload) => {
      commit('setShowingSelfcheckInitErrorModal', payload)
    },
    setShowingSelfcheckUnhandledErrorModal: ({ commit }, payload) => {
      commit('setShowingSelfcheckUnhandledErrorModal', payload)
    },
  },
  mutations: {
    setShowingCallingStaffModal(state, isShowingCallingStaffModal) {
      state.showingCallingStaffModal = isShowingCallingStaffModal
    },
    setShowingCheckingOutModal(state, isShowingCheckingOutModal) {
      state.showingCheckingOutModal = isShowingCheckingOutModal
    },
    setShowingChildrenAuthorizedModal(state, isShowingChildrenAuthorizedModal) {
      state.showingChildrenAuthorizedModal = isShowingChildrenAuthorizedModal
    },
    setShowingOrderQuittingModal(state, isShowingOrderQuittingModal) {
      state.showingOrderQuittingModal = isShowingOrderQuittingModal
    },
    setShowingQRForChildrenModal(state, isShowingQRForChildrenModal) {
      state.showingQRForChildrenModal = isShowingQRForChildrenModal
    },
    setShowingScheduledRecommendModal(state, isShowingScheduledRecommendModal) {
      state.showingScheduledRecommendModal = isShowingScheduledRecommendModal
    },
    setShowingSeatAuthorizedModal(state, isShowingSeatAuthorizedModal) {
      state.showingSeatAuthorizedModal = isShowingSeatAuthorizedModal
    },
    setShowingShopAuthorizedModal(state, isShowingShopAuthorizedModal) {
      state.showingShopAuthorizedModal = isShowingShopAuthorizedModal
    },
    setShowingSimpleErrorModal(state, bool) {
      state.showingSimpleErrorModal = bool
    },
    setShowingTutorialModal(state, isShowingTutorialModal) {
      state.showingTutorialModal = isShowingTutorialModal
    },
    setShowingBirthMonthEventModal(state, isShowingBirthMonthEventModal) {
      state.showingBirthMonthEventModal = isShowingBirthMonthEventModal
    },
    setShowingReserveInfoModal(state, isShowingReserveInfoModal) {
      state.showingReserveInfoModal = isShowingReserveInfoModal
    },
    setShowingVoiceSearchModal(state, isShowingVoiceSearchModal) {
      state.showingVoiceSearchModal = isShowingVoiceSearchModal
    },
    setShowingPreOrderWarningModal(state, isShowingPreOrderWarningModal) {
      state.showingPreOrderWarningModal = isShowingPreOrderWarningModal
    },
    setShowingPlayBikkuraponModal: (state, bool) => {
      state.showingPlayBikkuraponModal = bool
    },
    setShowingBikkuraponBusyModal: (state, bool) => {
      state.showingBikkuraponBusyModal = bool
    },
    setShowingBikkuraponErrorModal: (state, bool) => {
      state.showingBikkuraponErrorModal = bool
    },
    setShowingBikkuraponAnimationModal: (state, bool) => {
      state.showingBikkuraponAnimationModal = bool
    },
    setShowingSelfcheckModal(state, bool) {
      state.showingSelfcheckModal = bool
    },
    setShowingSelfcheckCallingModal(state, bool) {
      state.showingSelfcheckCallingModal = bool
    },
    setShowingSelfcheckErrorModal(state, bool) {
      state.showingSelfcheckErrorModal = bool
    },
    setShowingSelfcheckInitErrorModal(state, bool) {
      state.showingSelfcheckInitErrorModal = bool
    },
    setShowingSelfcheckUnhandledErrorModal(state, bool) {
      state.showingSelfcheckUnhandledErrorModal = bool
    },
  },
}

export default modal
